// todo: add the others modules
const VALIDATION_WORKFLOW_MODULE = 'VALIDATION_WORKFLOW';
const MODULE_EXTERNAL_STORAGE = 'EXTERNAL_STORAGE';
const MODULE_EMBEDDED_LINKS = 'EMBEDDED_LINKS';

export {
    VALIDATION_WORKFLOW_MODULE,
    MODULE_EXTERNAL_STORAGE,
    MODULE_EMBEDDED_LINKS,
};
